// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 3 hooks for backend/shortPay.

import { useBackend } from '../useBackend'

/** POST /api/shortPay/decideShortPay */
export function useDecideShortPay<T = any>() {
  return useBackend<T>('shortPay/decideShortPay')
}

/** POST /api/shortPay/getShortPay */
export function useGetShortPay<T = any>() {
  return useBackend<T>('shortPay/getShortPay')
}

/** POST /api/shortPay/raiseShortPay */
export function useRaiseShortPay<T = any>() {
  return useBackend<T>('shortPay/raiseShortPay')
}
